module.exports = __webpack_public_path__ + "img/joy.f64a4cb0.png";